import { castDraft, immerable, produce } from 'immer';
import { Map } from 'immutable';

import { InstanceModule } from './instance-module';
import { ModuleRole } from './module-role';
import { Preferences } from './preferences';

interface ICurrentUser {
	id: number;
	login: string;
	userName: string;
	primaryOrganizationId: number;
	accounts: Map<number, Array<ModuleRole>>;
	preferences: Preferences;
	availableInstanceModules: Map<string, InstanceModule>;
}

const entityDefaults: ICurrentUser = {
	id: -1,
	login: '',
	userName: '',
	preferences: Preferences.build(),
	primaryOrganizationId: -1,
	accounts: Map(),
	availableInstanceModules: Map(),
};

export class CurrentUser implements ICurrentUser {
	private [immerable] = true;
	public id = entityDefaults.id;
	public login = entityDefaults.login;
	public userName = entityDefaults.userName;
	public primaryOrganizationId = entityDefaults.primaryOrganizationId;
	public accounts = entityDefaults.accounts;
	public preferences = entityDefaults.preferences;
	public availableInstanceModules = entityDefaults.availableInstanceModules;

	public static build(params: Partial<ICurrentUser> = {}): CurrentUser {
		const inst = new CurrentUser();
		inst.id = params.id ?? entityDefaults.id;
		inst.login = params.login ?? entityDefaults.login;
		inst.userName = params.userName ?? entityDefaults.userName;
		inst.primaryOrganizationId =
			params.primaryOrganizationId ?? entityDefaults.primaryOrganizationId;
		inst.preferences = params.preferences ?? entityDefaults.preferences;
		inst.accounts = params.accounts ?? entityDefaults.accounts;
		inst.availableInstanceModules =
			params.availableInstanceModules ??
			entityDefaults.availableInstanceModules;

		return inst;
	}

	public setAvailableInstanceModules(
		instances: Map<string, InstanceModule>,
	): CurrentUser {
		return produce(this, (draft) => {
			draft.availableInstanceModules = castDraft(instances);
		});
	}

	public setPreferences(pref: Preferences): CurrentUser {
		return produce(this, (draft) => {
			draft.preferences = castDraft(pref);
		});
	}

	public setPrimaryOrganization(selected: number): CurrentUser {
		return produce(this, (draft) => {
			draft.primaryOrganizationId = selected;
		});
	}
}
